import React from "react";

export default function J2VPlayer(props) {

    // const webPlayerURL = "https://web.json2video.com/player-dev/index.html";
    const webPlayerURL = "https://web.json2video.com/player/index.html";

    const maxWidth = props.maxWidth || 500;
    const maxHeight = props.maxHeight || 500;

    const [iframeLoaded, setIFrameLoaded] = React.useState(false);
    const playerRef = React.useRef();
    const [timecode, setTimecode] = React.useState(0);
    const [movieDuration, setMovieDuration] = React.useState(0);
    const [sliderDisabled, setSliderDisabled] = React.useState(true);
    const [isPlaying, setIsPlaying] = React.useState(false);
    const [movieAspectRatio, setMovieAspectRatio] = React.useState(16/9);
    const [movieWidth, setMovieWidth] = React.useState(0);
    const [movieHeight, setMovieHeight] = React.useState(0);

    React.useEffect(() => {
        // when the component is loaded, register a listener for the messages from the J2VPlayer
        window.addEventListener("message", listenJ2VPlayer);
    }, []);

    React.useEffect(() => {
        if (iframeLoaded) {
            // console.log("J2VPlayerSDK: JSON changed, updating iframe");
            playerRef.current.contentWindow.postMessage({
                source: "j2vapp",
                action: "load",
                movie: props.movie
            }, '*');
            // setMovieSize();
        }
    }, [props.movie, iframeLoaded]);

    React.useEffect(() => {
        // pass the selected element to the J2VPlayer
        playerRef.current.contentWindow.postMessage({
            source: "j2vapp",
            action: "select",
            element: props.selectedElement
        }, '*');
    }, [props.selectedElement]);

    const transparentBackground = {
        backgroundColor: '#e5e5f7',
        backgroundImage: 'repeating-linear-gradient(45deg, #F5F5F5 25%, transparent 25%, transparent 75%, #F5F5F5 75%, #F5F5F5), repeating-linear-gradient(45deg, #F5F5F5 25%, #E5E5E5 25%, #E5E5E5 75%, #F5F5F5 75%, #F5F5F5)',
        backgroundPosition: '0 0, 5px 5px',
        backgroundSize: '10px 10px',
        borderRadius: '5px',
        overflow: 'hidden'
    };

    return (
        <div id="j2v-playerContainer">
            <div id="j2v-iframeContainer" style={transparentBackground}>
                <iframe ref={playerRef} title="player" src={webPlayerURL}
                    style={{width:'100%',aspectRatio:movieAspectRatio,border:0,margin:"0 auto",borderRadius:"5px"}}
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    onLoad={onIFrameLoaded}></iframe>
            </div>
            <div className="j2v-control-bar">
                <div id="j2v-controlBar" style={{ padding: "1% 0", display: "flex", justifyContent: "space-between" }}>
                    <div style={{ width: "8%", display: "flex", alignItems: "center", justifyContent: "space-around" }}>
                        {
                            (isPlaying) ?
                            <svg onClick={pause} id="j2v-pauseButton" style={{ cursor: "pointer" }} width="60%" fill="currentColor" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M9 5H7a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1Z"></path><path d="M17 5h-2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1Z"></path></svg>
                            :
                            <svg onClick={play} id="j2v-playButton" style={{ cursor: "pointer" }} width="60%" fill="currentColor" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M7 4v16l13-8L7 4Z"></path></svg>
                        }
                    </div>
                    <div style={{flexGrow:1,padding:'0 1%',display:'flex',alignItems:'center',justifyContent:'center'}}>
                        <input id="j2v-progress" className="j2v-progress-bar" type="range" min="0" max={movieDuration} value={timecode} step="0.1" style={{width:"100%"}} 
                            disabled={sliderDisabled}
                            onChange={onProgressChange} />
                    </div>
                </div>
                <div style={{ height:"20px", fontSize:"80%", display:"flex", alignItems:"center", justifyContent:"center"}}>
                    <div>Timecode: {timecode}s | Movie duration: {movieDuration}s</div>
                </div>
            </div>
        </div>
    );

    // -----

    function onIFrameLoaded() {
        // console.log("J2VPlayer: iframeLoaded");
        setIFrameLoaded(true);
    }

    function listenJ2VPlayer(event) {
        const data = event.data;
        if (data.source === "j2vplayer") {
            
            switch (data.event) {
                case "ready":
                    // console.log("J2VPlayerSDK received a 'ready' state from J2VPlayer", event.data);
                    onReady(data);
                    break;

                case "timecode":
                    onTimecode(data);
                    break;

                case "select":
                    onElementSelected(data);
                    break;

                case "move":
                    onElementMoved(data);
                    break;

                case "resize":
                    onElementResized(data);
                    break;

                default:
            }
        }
    }

    function play() {
        setIsPlaying(true);
        playerRef.current.contentWindow.postMessage({
            source: "j2vapp",
            action: "play"
        }, '*');
    }

    function pause() {
        setIsPlaying(false);
        playerRef.current.contentWindow.postMessage({
            source: "j2vapp",
            action: "pause"
        }, '*');
    }

    function onReady(data) {
        if ("duration" in data && data.duration>0) {
            setSliderDisabled(false);
            setMovieDuration(Math.round(data.duration*10)/10);
        }
        else return;

        if ("aspectRatio" in data) setMovieAspectRatio(data.aspectRatio);
        if ("width" in data) setMovieWidth(data.width);
        if ("height" in data) setMovieHeight(data.height);

        setMovieSize(data.width, data.height, data.aspectRatio);
    }

    function setMovieSize(width=null, height=null, aspectRatio=null) {

        if (!playerRef || !playerRef.current) return;

        if (!width) width = movieWidth;
        if (!height) height = movieHeight;
        if (!aspectRatio) aspectRatio = movieAspectRatio;

        // resize iframe based on aspect ratio honouring max sizes
        // console.log("Resizing the J2VPlayer iframe");

        const rootAspectRatio = maxWidth / maxHeight;
        // console.log("rootAspectRatio: ", rootAspectRatio);
        // console.log("maxWidth: ", maxWidth, "maxHeight: ", maxHeight);
        // console.log("movie aspectRatio: ", aspectRatio);

        if (rootAspectRatio > aspectRatio) {
            const 
                playerHeight = maxHeight, 
                playerWidth = playerHeight * (aspectRatio*0.87);
            // playerRef.current.style.height = playerHeight + "px";
            playerRef.current.style.width = playerWidth + "px";
            // console.log("root>movie :: playerHeight: ", playerHeight, "playerWidth: ", playerWidth);
        }
        else {
            let 
                playerWidth = maxWidth, 
                playerHeight = playerWidth / (aspectRatio*0.87);
            
            if (playerHeight > maxHeight) { 
                playerHeight = maxHeight; 
                playerWidth = playerHeight * (aspectRatio*0.87);
            }

            playerRef.current.style.width = playerWidth + "px";
            playerRef.current.style.aspectRatio = aspectRatio;
            
            // console.log("root<movie :: playerWidth: ", playerWidth, "playerHeight: ", playerHeight);
        }
    }

    function onTimecode(data) {
        if ("timecode" in data) {
            // console.log("timecode: ", JSON.parse(JSON.stringify(data)));
            setTimecode(data.timecode);
        }
    }

    function onProgressChange(event) {
        const progressValue = event.nativeEvent.target.value;
        setTimecode(progressValue);
        playerRef.current.contentWindow.postMessage({
            source: "j2vapp",
            action: "seek",
            time: progressValue
        }, '*');
    }

    function onElementSelected(data) {
        // change the selected element based on what user clicked on the webplayer
        // console.log("onElementSelected(): Changing the selected element as per webplayer request...", data);
        props.changeSelectedElement(data.element);
    }

    function onElementMoved(data) {
        // console.log("onElementMoved(): Moving the selected element as per webplayer request...", data);
        props.moveSelectedElement(data);
    }

    function onElementResized(data) {
        props.resizeSelectedElement(data);
    }
}